module.exports = __webpack_public_path__ + "static/media/controls-tablet.d56c1269.png";